import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import AppContext from "./appContext";
import Cookies from "js-cookie";

const AppState = ({ children }) => {
  const [appTheme, setAppTheme] = useState(
    localStorage.getItem("hrm-theme") === "dark-theme" ? "dark" : "light"
  );
  const location = useLocation();
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);
  const [sideBarItemKey, setSideBarItemKey] = useState(null);
  const [user, setUser] = useState(null);
  const [taskId, setTaskId] = useState(null);

  useEffect(() => {
    setSideBarItemKey(location.pathname);
  }, [location]);

  useEffect(() => {
    check();
    // eslint-disable-next-line
  }, [location.pathname]);

  // check user
  const check = () => {
    if (!Cookies.get("kashanPlusUser")) {
      setUser(null);
      navigate("/");
    } else {
      setUser(JSON.parse(Cookies.get("kashanPlusUser")));
    }
  };

  //logout user
  const userLogout = () => {
    Cookies.remove("kashanPlusUser");
    setUser(null);
    navigate("/");
  };
  return (
    <AppContext.Provider
      value={{
        collapse: collapse,
        setCollapse,
        sideBarItemKey: sideBarItemKey,
        setSideBarItemKey,
        user: user,
        setUser,
        userLogout,
        taskId,
        setTaskId,
        appTheme,
        setAppTheme,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppState;
